// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app .cargo-number-input[data-v-3e580d8a] input{\n  text-align:right;\n}\n.row-top-5[data-v-3e580d8a] {\n  margin-top: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
